<!--eslint-disable-->
<template >
  <div class="groupBooking f16">
    <div class="lin_15 f16 gray_3 fb">
      拼团策略 - 拼团详情
    </div>
    <div class="box20"></div>
    <div class=" t_right">
      <span class="group_btn b_red white f16 t_center" @click="toGroupList">返回活动列表</span>
    </div>
    <div class="box20"></div>
    <div>
      <p class="ps_main_head">温馨提示：最终的价格，以商品列表计算后展示的价格为准</p>
      <el-form ref="form" :model="activity" label-width="160px">
        <el-form-item label="拼团活动名称">
          <span>{{activity.title}}</span>
        </el-form-item>
        <el-form-item label="活动时间">
          <span>{{activity.startTimeStr}} - {{activity.endTimeStr}}</span>
          <span class="pad30_l red f12">提示：活动结束，活动商品自动转为原价</span>
        </el-form-item>
        <el-form-item label="公开展示">
          <span v-if="activity.isPublic">是</span>
          <span v-else>否</span>
          <span class="pad30_l red f12">提示：若信息非公开展示，则会在列表页生成专属活动链接</span>
        </el-form-item>
        <el-form-item label="拼团类型">
          <div class="groupType" v-if="activity.groupType === 1">
            <p>促活团</p>
            <p class="pad10_t">该团适用于店铺促活，全部用户</p>
            <p>均可参与</p>
          </div>
          <div class="groupType" v-if="activity.groupType === 2">
            <p>拉新团</p>
            <p class="pad10_t">该团使用店铺拉新，仅限新用户</p>
            <p>(仅在商城下单的用户)参与</p>
          </div>
        </el-form-item>
        <el-form-item label="活动商品">
        </el-form-item>
        <el-table
          v-if="checkGoodsList.length"
          ref="multipleTable"
          :data="checkGoodsList"
          tooltip-effect="dark"
          style="width: 100%"
          class="mar20_b">
          <el-table-column
            prop="name"
            label="货品名称"
            width="200">
          </el-table-column>
          <el-table-column
            prop="spec"
            label="规格"
            width="80">
          </el-table-column>
          <el-table-column
            prop="marketPriceStr"
            label="原价(元)"
            width="90">
          </el-table-column>
          <el-table-column
            prop="sponsorPrice"
            label="团长价"
            width="110">
          </el-table-column>
          <el-table-column
            prop="goodsPrice"
            label="拼团价"
            width="110">
          </el-table-column>
          <el-table-column
            prop="peopleLimit"
            label="成团人数"
            width="110">
          </el-table-column>
          <el-table-column
            prop="goodsQuantity"
            label="活动商品数"
            width="110">
          </el-table-column>
          <el-table-column
            prop="volumeLimit"
            label="限制开团次数">
          </el-table-column>
        </el-table>
        <el-form-item label="是否设置团长福利">
          <span v-if="activity.activityDtl.sponsorRewardType === 1">优惠券</span>
          <span v-else-if="activity.activityDtl.sponsorRewardType === 2">商品</span>
          <span v-else>无</span>
          <span class="pad30_l red f12" v-if="activity.activityDtl.sponsorRewardType === 2">提示：拼团成功后，默认为团长生成一笔当前商品0元的订单，请及时发货</span>
          <div v-if="activity.activityDtl.sponsorRewardType === 1">
            <div class="mar20_t coupon_list">
              <ul class="clear f12 white">
                <li v-for="(coupon,index) in checkCouponList" v-bind:key="coupon.regCode">
                  <div class="clear coupon_price">
                    <span class="float-left f24 lin_30">{{coupon.regVal}}</span>
                    <div class="float-right t_right">
                      <p>满{{coupon.regKey}}元可用</p>
                      <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                      <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                      <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                    </div>
                  </div>
                  <p class="t_center">领取时间：{{coupon.startTimeStr}}至{{coupon.endTimeStr}}</p>
                  <p class="t_center">使用时间：{{coupon.useStartTimeStr}}至{{coupon.useEndTimeStr}}</p>
                  <div class="clear coupon_num gray_3">
                    <p class="float-left">数量：<em class="red">{{coupon.surplusNum}}</em></p>
                    <p class="float-right" v-if="coupon.residueEndDay">即将到期</p>
                    <!--<span class="float-right" v-if="coupon.residueEndDay">即将到期</span>-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="拼团失败补偿">
          <span v-if="activity.activityDtl.failRewardType === 1">优惠券</span>
          <span v-else>无</span>
          <div v-if="activity.activityDtl.failRewardType === 1">
            <div class="mar20_t coupon_list">
              <ul class="clear f12 white">
                <li v-for="(coupon,index) in compensationCouponList" v-bind:key="coupon.regCode">
                  <div class="clear coupon_price">
                    <span class="float-left f24 lin_30">{{coupon.regVal}}</span>
                    <div class="float-right t_right">
                      <p>满{{coupon.regKey}}元可用</p>
                      <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                      <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                      <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                    </div>
                  </div>
                  <p class="t_center">领取时间：{{coupon.startTimeStr}}至{{coupon.endTimeStr}}</p>
                  <p class="t_center">使用时间：{{coupon.useStartTimeStr}}至{{coupon.useEndTimeStr}}</p>
                  <div class="clear coupon_num gray_3">
                    <p class="float-left">数量：<em class="red">{{coupon.surplusNum}}</em></p>
                    <p class="float-right" v-if="coupon.residueEndDay">即将到期</p>
                    <!--<span class="float-right" v-if="coupon.residueEndDay">即将到期</span>-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="分享图片">
          <a v-if="activity.activityDtl" :href="activity.activityDtl.shareImage" target="_blank">
            <img width="20%" :src="`${activity.activityDtl.shareImage}?imageMogr2/thumbnail/120000@`" alt="">
          </a>
        </el-form-item>
        <el-form-item label="顶部宣传图">
          <a v-if="activity.activityDtl" :href="activity.activityDtl.coverImage" target="_blank">
            <img width="20%" :src="`${activity.activityDtl.coverImage}?imageMogr2/thumbnail/120000@`" alt="">
          </a>
        </el-form-item>
        <el-form-item label="活动规则">
          <div v-html="TinymceMain"></div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      TinymceMain: "",
      contentInit: {},
      activityId: "",
      origin: process.env,
      shareVisible: false,
      topImage: {},
      shareImage: {},
      topVisible: false,
      content: null,
      editorOption: {},
      activity: {
        title: "",
        isPublic: 0,
        date: "",
        groupType: "",
        startTime: "",
        endTime: "",
        activityDtl: {
          sponsorRewardType: 1,
          failRewardType: 1,
          shareImage: "",
          coverImage: "",
        },
        activityGoodsList: [],
      },
      activitys: {},
      checkCouponList: [], // 团长补偿的优惠券
      compensationCouponList: [], // 成团失败补偿的优惠券
      isCompensation: false, // 是否显示成团失败补偿的优惠券弹窗
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
        isGroup: 1,
      },
      // 禁用选择当前时间之前
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.activityId = this.$route.query.activityId;
    this.listShopCoupon();
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    // 获取优惠券
    listShopCoupon() {
      this.$store.dispatch("coupon/coupon/getShopCouponList").then((data) => {
        if (data) {
          this.shopCouponList = data;
          this.shopCouponList.forEach((coupon) => {
            this.$set(coupon, "isCheck", false);
          });
        }
        if (this.activityId) {
          this.detail();
        }
      });
    },
    detail() {
      this.$store.dispatch("group/groupActivity/detail", this.activityId).then((data) => {
        if (!data.data) {
          return;
        }
        const activity = data.data;
        console.log(activity);
        activity.date = [activity.startTimeStr,activity.endTimeStr]; //eslint-disable-line
        // 商品
        const { activityGoodsList } = activity;
        if (activityGoodsList) {
          activityGoodsList.forEach((goods) => {
            if (goods.goodsEntity) {
              goods.name = goods.goodsEntity.name;
              goods.spec = goods.goodsEntity.spec;
              goods.marketPriceStr = goods.goodsEntity.marketPriceStr;
              goods.picUrl = goods.goodsEntity.picUrl;
            }
            if (!goods.volumeLimit || goods.volumeLimit === 0) {
              goods.volumeLimit = "";
            }
          });
        }
        this.checkGoodsList = activityGoodsList;
        // 优惠券
        const { activityDtl } = activity;
        const checkCouponList = [];
        const compensationCouponList = [];
        if (this.shopCouponList) {
          this.shopCouponList.forEach((coupon) => {
            coupon.isCheck = false;
            if (activityDtl.successRewardRule.indexOf(coupon.regCode) !== -1) {
              coupon.isCheck = true;
              checkCouponList.push(coupon);
            }
            if (activityDtl.failRewardRule.indexOf(coupon.regCode) !== -1) {
              coupon.isCheck = true;
              compensationCouponList.push(coupon);
            }
          });
        }
        this.checkCouponList = checkCouponList;
        this.compensationCouponList = compensationCouponList;
        // 图片
        const shareImageUrl = [];
        const topImageUrl = [];
        if (activityDtl.shareImage) {
          shareImageUrl.push({
            name: "",
            url: activityDtl.shareImage,
          });
        }
        if (activityDtl.coverImage) {
          topImageUrl.push({
            name: "",
            url: activityDtl.coverImage,
          });
        }
        if (shareImageUrl.length > 0) {
          this.shareImageUrl = shareImageUrl;
        }
        if (topImageUrl.length > 0) {
          this.topImageUrl = topImageUrl;
        }
        this.TinymceMain = activityDtl.description;
        this.activity = activity;
      });
    },
    toGroupList() {
      this.$router.push("/mj/groupList");
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
@import "index";
</style>
